import api from '@/factories/api';

export default {
  namespaced: true,

  state: {
    loading: false,
    serviceAccounts: [],
    apiKeys: [],
    pendingCreatedKey: null,
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setServiceAccounts(state, accounts) {
      state.serviceAccounts = accounts || [];
    },
    setApiKeys(state, keys) {
      state.apiKeys = keys || [];
    },
    setPendingCreatedKey(state, payload) {
      state.pendingCreatedKey = payload;
    },
    clearPendingCreatedKey(state) {
      state.pendingCreatedKey = null;
    },
  },

  actions: {
    async loadServiceAccounts({ commit }) {
      commit('setLoading', true);
      try {
        const res = (await api().get('service-accounts')) || [];
        commit('setServiceAccounts', res);
        return res;
      } finally {
        commit('setLoading', false);
      }
    },

    async createServiceAccount({ commit, dispatch }, payload) {
      commit('setLoading', true);
      try {
        const res = await api().post('service-accounts', payload);
        await dispatch('loadServiceAccounts');
        commit('users/resetUsersCache', null, { root: true });
        return res;
      } finally {
        commit('setLoading', false);
      }
    },

    async updateServiceAccount({ commit, dispatch }, { id, data }) {
      commit('setLoading', true);
      try {
        const res = await api().put(`service-accounts/${id}`, data);
        await dispatch('loadServiceAccounts');
        return res;
      } finally {
        commit('setLoading', false);
      }
    },

    async deleteServiceAccount({ commit, dispatch }, id) {
      commit('setLoading', true);
      try {
        await api().delete(`service-accounts/${id}`);
        await dispatch('loadServiceAccounts');
        commit('users/resetUsersCache', null, { root: true });
      } finally {
        commit('setLoading', false);
      }
    },

    async loadApiKeys({ commit }, options = {}) {
      const type = typeof options === 'string' ? options : options.type || '';
      const silent = typeof options === 'object' && options.silent;

      if (!silent) {
        commit('setLoading', true);
      }

      try {
        const params = type ? { type } : {};
        const res = (await api().get('api-keys', { params })) || [];
        commit('setApiKeys', res);
        return res;
      } finally {
        if (!silent) {
          commit('setLoading', false);
        }
      }
    },

    async createApiKey({ commit, dispatch }, payload) {
      const res = await api().post('api-keys', payload);

      if (res?.token) {
        commit('setPendingCreatedKey', {
          token: res.token,
          keyType: payload.type || 'custom',
        });
      }

      dispatch('loadApiKeys', { silent: true }).catch(() => {});
      return res;
    },

    async updateApiKey({ dispatch }, { id, data }) {
      const res = await api().put(`api-keys/${id}`, data);
      await dispatch('loadApiKeys', { silent: true });
      return res;
    },

    async renewApiKey({ dispatch }, { id, expirationPreset }) {
      const res = await api().post(`api-keys/${id}/renew`, {
        expiration_preset: expirationPreset,
      });
      await dispatch('loadApiKeys', { silent: true });
      return res;
    },

    async revokeApiKey({ dispatch }, id) {
      await api().delete(`api-keys/${id}`);
      await dispatch('loadApiKeys', { silent: true });
    },

    clearPendingCreatedKey({ commit }) {
      commit('clearPendingCreatedKey');
    },
  },
};
